import React from "react";
import styled from "styled-components";

interface TransactionMethodsProps {
  onOrderClick: () => void;
}

const TransactionMethods: React.FC<TransactionMethodsProps> = () => {
  return (
    <Container>
      <InnerContainer>
        <Row>
          <Label>상품 상태</Label>
          <Value>거의 새 것</Value>
        </Row>
        <Row>
          <Label>결제 방법</Label>
          <Value>결제 방식은 판매자와 협의</Value>
        </Row>
        <Row>
          <Label>배송 방법</Label>
          <Value>택배 거래, 직거래</Value>
        </Row>
      </InnerContainer>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 10px;
  background-color: #fff;
`;

const InnerContainer = styled.div`
  padding: 10px 0;
  padding-left: 26px;
  padding-right: 20px;
  max-width: 500px;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 0;
  gap: 40px;
`;

const Label = styled.span`
  color: rgba(159, 159, 159, 1);
  font-size: 17px;
  min-width: 70px;
`;

const Value = styled.span`
  color: #333;
  font-size: 16px;
  font-weight: 500;
`;

export default TransactionMethods;
